// extracted by mini-css-extract-plugin
export default {"wrapper":"AcceptPrivacyInfoText_wrapper__EjzQu","link":"AcceptPrivacyInfoText_link__mLGMy"};